// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"MenuDropdown_dropdown__3-zsR","background":"MenuDropdown_background__2e2nG"};